import React, { useState, useRef, useMemo } from 'react';

interface InputInterface {
  setSelectedElement: (value: string | null) => void;
  selectedElement?: string | null;
  name: string;
  label: string;
  setter: (value: string) => void;
  getter: string;
  errors?: Record<string, string> | null;
  required?: boolean;
}

export const InputWithLabel: React.FC<InputInterface> = ({
  setSelectedElement,
  name,
  label,
  setter,
  getter,
  errors,
  required,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const errorKey = useMemo(() => name.toLowerCase().replace(/\s+/g, ''), [
    name,
  ]);

  const shouldFloat = useMemo(() => isFocused || getter, [getter, isFocused]);

  const handleFocus = () => {
    setIsFocused(true);
    setSelectedElement(label);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setSelectedElement(null);
  };

  return (
    <div
      style={{
        position: 'relative',
        marginBottom: '12px',
        minWidth: '100%',
      }}
    >
      <label
        className={`form-input-label contact-form-label ${
          shouldFloat ? 'form-input-label-floated' : 'form-input-label-default'
        }`}
        htmlFor={name}
        style={{
          position: 'absolute',
          left: '12px',
          top: '12px',
          pointerEvents: 'none',
          transition: 'all 0.2s ease-out',
          transformOrigin: 'left center',
          backgroundColor: shouldFloat ? 'black' : 'transparent',
          padding: shouldFloat ? '0 4px' : '0',
          zIndex: shouldFloat ? 1 : 0,
        }}
        onClick={() => inputRef.current?.focus()}
      >
        {label}
        {required && (
          <span style={{ color: '#ee2737', marginLeft: '4px' }}>*</span>
        )}
      </label>

      <input
        ref={inputRef}
        id={name}
        name={name}
        value={getter}
        maxLength={80}
        onChange={e => setter(e.target.value)}
        className="asda-input"
        style={{
          padding: '12px',
          position: 'relative',
          width: '100%',
          borderColor: errors?.[errorKey] ? '#FF2238' : undefined,
        }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete="off"
      />

      {errors?.[errorKey] && (
        <p className="asda__error__message">{errors[errorKey]}</p>
      )}
    </div>
  );
};
